import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
};

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
};

export const chargeUpdateDialogReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.GLOBAL_CHARGE_UPDATE_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case Constants.GLOBAL_CHARGE_UPDATE_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case Constants.GLOBAL_CHARGE_UPDATE_FAILURE:
      const chargeFields = [];

      if (action.payload?.err.fields.includes("invoiceDate")) {
        chargeFields.push("invoiceDateForCharge");
      }

      if (action.payload?.err.fields.includes("invoiceNumber")) {
        chargeFields.push("invoiceNumberForCharge");
      }

      if (action.payload?.err.fields.includes("amount")) {
        chargeFields.push("amountForCharge");
      }
      
      if (action.payload?.err.fields.includes("currency")) {
        chargeFields.push("currencyIdForCharge");
      }
      
      if (action.payload?.err.fields.includes("vat")) {
        chargeFields.push("vatForCharge");
      }

      if (action.payload?.err.fields.includes("newChargetype")) {
        chargeFields.push("typeIdForCharge");
      }

      if (action.payload?.err.fields.includes("contactId")) {
        chargeFields.push("selectedPersonForCharge");
        chargeFields.push("counterpartyId");
      }

      if (action.payload?.err.fields.includes("companyId")) {
        chargeFields.push("selectedCompanyForCharge");
        chargeFields.push("counterpartyId");
      }

      if (action.payload?.err.fields.includes("newChargecontactId")) {
        chargeFields.push("selectedPersonForCharge");
      }

      if (action.payload?.err.fields.includes("newChargecompanyId")) {
        chargeFields.push("selectedCompanyForCharge");
      }

      if (action.payload?.err.fields.includes("objectId")) {
        chargeFields.push("objectId")
      }

      if (action.payload?.err.message === "Charge requires at least one relation"
        || (action.payload?.err.fields.indexOf("propertyId") > -1 &&
        action.payload?.err.fields.indexOf("unitId") > -1 &&
        action.payload?.err.fields.indexOf("contractId") > -1)) {
        chargeFields.push("objectId");
      }

      if (action.payload?.err.fields.includes("firstDate")) {
        chargeFields.push("firstDateForCharge");
      }

      if (action.payload?.err.fields.includes("dateOfPeriod")) {
        chargeFields.push("dateOfPeriodForCharge");
      }

      if (action.payload?.err.fields.includes("description")) {
        chargeFields.push("descriptionForCharge");
      }

      return {
        ...state,
        isFetching: false,
        fields: chargeFields,
        translatedMessage: action.payload?.err.translatedMessage
      };
      
    case Constants.GLOBAL_CHARGE_TYPE_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_BANK_ACCOUNT_CREATE_FAILURE:
      return {
        ...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.GLOBAL_EVENT_CREATE_FAILURE:
    case Constants.GLOBAL_EVENT_UPDATE_FAILURE:
      const errorFields: string[] = [];

      if (action.payload?.err.fields.length > 0) {
        action.payload?.err.fields.forEach(error => {
          if(error === "content.name") {
            return errorFields.push("name");
          }
    
          if(error === "content.note") {
            return errorFields.push("note");
          }

          if (error === "propertyId" ||
              error === "unitId" ||
              error === "contractId" ||
              error === "companyId" ||
              error === "personId") {
            return errorFields.push("objectId");
          }

          return errorFields.push(error);
        });
      }
      
      return {
        ...state,
        isFetching: false,
        fields: errorFields,
        translatedMessage: action.payload?.err.translatedMessage
      };
      
    case Constants.GLOBAL_CHARGE_UPDATE_CLEAR:
    case Constants.GLOBAL_PAYMENT_CREATE_CLEAR:
    case Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR: 
    case Constants.GLOBAL_BANK_ACCOUNT_CREATE_CLEAR:  
    case Constants.GLOBAL_CHARGE_SEND_CLEAR:
    case Constants.GLOBAL_EVENT_CREATE_CLEAR:
    case Constants.GLOBAL_EVENT_UPDATE_CLEAR:
    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
